import React, { useCallback, useEffect, useRef, useState } from 'react';
import * as styles from './index.module.less';
import { HEADER_NAV_DATA } from '@/layout/constants';
import NottaLogoLink from '@/components/notta-logo-link';
import NavDropdownWrapper from '../nav-dropdown-wrapper';
import { WEB_APP_JP_LOGIN_IN_URL, WEB_APP_JP_SIGN_UP_URL } from '@/constants';
import NavMenuBtn from '@/components/nav-menu-btn';
import SideNavBar from '../side-nav-bar';
import LanguagesSelector from '../languages-selector';
import { throttle } from 'lodash';

const NavBtn = ({ link, label, color = '#fff', bg = '#3089F0', borderColor = '#3089F0' }) => {
  return (
    <a
      href={link}
      className={styles.nav_btn_container}
      style={{
        background: bg,
        border: `2px solid ${borderColor}`,
      }}
    >
      <button
        style={{
          color: color,
        }}
        className={styles.nav_btn_label}
      >
        {label}
      </button>
    </a>
  );
};

interface IProp {
  getNavBarHeight?: (value: number) => void;
}

const HeaderNav = ({ getNavBarHeight }: IProp) => {
  const [isSideBarActive, setIsSideBarActive] = useState(false);
  const navRef = useRef<HTMLDivElement>(null);

  const handleNavMenuBtnClick = () => {
    setIsSideBarActive(!isSideBarActive);
  };

  const handleGetNavBarHeight = throttle(() => {
    const navBarHeight = navRef.current?.offsetHeight;
    getNavBarHeight?.(navBarHeight);
  }, 500);

  const handleWindowResize = useCallback(() => {
    handleGetNavBarHeight();
    if (isSideBarActive && window.innerWidth >= 1200) {
      setIsSideBarActive(false);
    }
  }, [handleGetNavBarHeight, isSideBarActive]);

  useEffect(() => {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [handleWindowResize]);

  return (
    <header className={styles.nav_wrapper} ref={navRef}>
      <div className={styles.nav_container}>
        {/* logo + 导航条 */}
        <div className={styles.logo_nav_container}>
          <NottaLogoLink />
          <nav className={styles.router_container}>
            {HEADER_NAV_DATA.map((item, index) => {
              return <NavDropdownWrapper key={index} data={item} />;
            })}
            <div className={styles.showcase_entry}>
              <a href="/showcase" className={styles.showcase_entry_label}>
                AI吹き替えツール
              </a>
            </div>
          </nav>
        </div>

        {/* 登陆注册按钮 & 菜单按钮 */}
        <div className={styles.login_btn_container}>
          <LanguagesSelector curLanguage="ja" className={styles.language_selector} showTriggerLabel atHeader />
          <NavBtn label="ログイン" link={WEB_APP_JP_LOGIN_IN_URL} color="#05080D" bg="#fff" borderColor="#363E47" />
          <NavBtn label="新規登録" link={WEB_APP_JP_SIGN_UP_URL} />
          <div className={styles.nav_menu_btn_container}>
            <NavMenuBtn isActive={isSideBarActive} handleClick={handleNavMenuBtnClick} />
          </div>
        </div>
      </div>
      {/* 侧边栏 */}
      <div className={`${styles.side_bar_wrapper} ${!isSideBarActive && styles.side_bar_wrapper_hidden}`}>
        <div
          className={`${styles.mask} ${isSideBarActive && styles.mask_active}`}
          onClick={handleNavMenuBtnClick}
        ></div>
        <div className={`${styles.side_bar_container} ${isSideBarActive && styles.side_bar_container_active}`}>
          <SideNavBar />
        </div>
      </div>
    </header>
  );
};
export default HeaderNav;
